import React from "react";
import './MaintenanceView.css';
import ST_LOGO from '../../images/st_logo.svg'


export default class MaintenanceView extends React.PureComponent<{}, { children?: React.ReactNode }> {
    public render() {
        return (
            <div className="maintenance-page">
                <div className="maintenance-container">
                    <img src={ST_LOGO} alt="Site Logo" className="logo" />
                    <h1 className="maintenance-title">Site Under Maintenance</h1>
                    <p className="maintenance-text">We regret any inconvenience caused and anticipate being back online shortly!</p>
                    <p className="maintenance-text">
                        <a href="https://steelandtube.co.nz/" className="backhome-button">
                            Home Page
                        </a>
                    </p>
                </div>
            </div>
        );
    }
}